// extracted by mini-css-extract-plugin
export var alignCenter = "_6c-d";
export var bannerShown = "_6c-6";
export var buttonContent = "_6c-0";
export var cardList = "_6c-1";
export var centerContent = "_6c-2";
export var chevron = "_6c-3";
export var closePanelButton = "_6c-k";
export var conversationContextContainer = "_6c-l";
export var conversationDetailContainer = "_6c-4";
export var detailWrapper = "_6c-7";
export var dropdownButton = "_6c-e";
export var dropdownTitle = "_6c-9";
export var fullHeight = "_6c-5";
export var hidden = "_6c-a";
export var icon = "_6c-b";
export var mergeSuggestionWrapper = "_6c-m";
export var panel = "_6c-i";
export var portalButtonsWrapper = "_6c-c";
export var right = "_6c-j";
export var tableSummaryContainer = "_6c-8";
export var tableSummaryHeader = "_6c-g";
export var threeDotsButton = "_6c-f";
export var wide = "_6c-h";